



















import Vue from 'vue';

import {
  // calender,
  brand,
  Brand,
  Booth,
  booth,
  item,
  Item,
  exhibitor,
  Exhibitor,
} from 'mostra';
import * as page from '@/modules/page';

interface DataType {
  loading: boolean;
  isChanged: boolean;
  targetPageName: string;
  editPageName: string;
  // currentPage: string | (string | null)[];
  brand: Brand | null;
  booths: Booth[];
  items: Item[];
  exhibitors: Exhibitor[];
  notFound: boolean;
  owner: string | null;
}

const pageParams = page.tabParams.brand;

export default Vue.extend({
  name: 'exhibitor-brand-edit',
  data(): DataType {
    return {
      loading: true,
      isChanged: false,
      // currentPage: '',
      targetPageName: 'exhibitor-brand-edit',
      editPageName: 'exhibitor-brand-edit',
      brand: null,
      booths: [],
      items: [],
      exhibitors: [],
      notFound: false,
      owner: null,
    };
  },
  computed: {
    brandId(): string | null {
      return this.$route.query.id as string;
    },
    currentPage(): string | null {
      return this.$route.query.page as string;
    },
  },
  watch: {
    brand: {
      handler(_, oldVal: any) {
        if (oldVal) {
          this.isChanged = true;
        }
      },
      deep: true,
    },
  },
  async beforeRouteLeave(to, from, next) {
    if (this.isChanged) {
      const r = await (this.$refs.dialog as any).show();
      next(r);
    } else {
      next();
    }
  },
  methods: {
    async toUpdateData() {
      try {
        if (!this.brand) {
          throw Error('this.brand id null');
        }
        const uid = this.$auth.uid;
        this.$loading(true);
        this.loading = true;
        this.brand = await brand.save(uid, this.brand);
        this.$success('保存しました。');
        this.isChanged = false;
        this.$router.push({
          name: this.editPageName,
          query: {
            page: 'preview',
            id: this.brand.id,
          },
        });
      } catch (error: any) {
        this.$error('保存に失敗しました。', error);
      } finally {
        this.loading = false;
        this.$loading(false);
      }
    },
    async fetchData() {
      try {
        if (this.brand) return;
        if (!this.brandId) {
          throw Error('brandId is null');
        }
        this.$loading(true);
        this.loading = true;

        this.owner = this.$auth.cid;
        if (!this.owner) throw Error('owner is null');

        this.brand = await brand.load(this.brandId);
        if (!this.brand) {
          this.notFound = true;
          return;
        }
        this.exhibitors = await exhibitor.loadsByCID(this.owner);
        this.booths = await booth.loadsByBrandId(this.owner, this.brandId);
        this.items = await item.loadsByBrandId(this.owner, this.brandId);
      } catch (error: any) {
        this.$fatal(error);
      } finally {
        this.loading = false;
        this.$loading(false);
      }
    },
    checkQueryParamsValid() {
      if (!this.currentPage || !pageParams.includes(this.currentPage)) {
        this.$router.push({
          name: this.targetPageName,
          // name: 'exhibitor-brand-edit',
          query: {
            ...this.$route.query,
            page: 'preview',
          },
        });
      }
    },
  },
  async beforeRouteUpdate(to, from, next) {
    next();
    // this.currentPage = to.query.page;
    this.checkQueryParamsValid();
    await this.fetchData();
  },
  async mounted() {
    // this.currentPage = this.$route.query.page;
    this.checkQueryParamsValid();
    await this.fetchData();
  },
});

